export enum EEvents {
    DOCUMENT_UPLOAD = 'document-upload',
    DOCUMENT_DELETE = 'document-delete',
}
